if (!customElements.get('infinite-scroll')) {
  customElements.define('infinite-scroll', class InfiniteScroll extends HTMLElement {
    connectedCallback() {
      this.gridContainer = document.getElementById('product-grid');
      this.loading = false;
      
      if (!this.gridContainer) return;

      this.observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting && !this.loading) {
            this.loadMore();
          }
        });
      }, { rootMargin: '100px' });

      this.observer.observe(this);
    }

    disconnectedCallback() {
      if (this.observer) this.observer.disconnect();
    }

    loadMore() {
      const nextUrl = this.getAttribute('data-next-url');
      if (!nextUrl) return;

      this.loading = true;

      fetch(nextUrl)
        .then(response => response.text())
        .then(responseText => {
          const parser = new DOMParser();
          const html = parser.parseFromString(responseText, 'text/html');
          
          const newItems = html.querySelectorAll('#product-grid > .grid__item, #product-grid > .article');
          const nextElement = html.querySelector('infinite-scroll');

          if (newItems.length > 0) {
            newItems.forEach(item => {
              item.classList.remove('scroll-trigger', 'animate--slide-in');
              this.gridContainer.appendChild(item);
            });
          }

          if (nextElement && nextElement.getAttribute('data-next-url')) {
            this.setAttribute('data-next-url', nextElement.getAttribute('data-next-url'));
            this.loading = false;
          } else {
            this.remove();
          }
        })
        .catch(() => {
          this.loading = false;
        });
    }
  });
}